import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MetaPixelPageTracker } from '../utils/metaPixel';
import { GTagPageTracker } from '../utils/gtag';
import Main from '../pages/Dashboard/Main';
import Login from '../pages/Public/Login';
import ForgotPassword from '../pages/Public/ForgotPassword';
import ResetPassword from '../pages/Public/ResetPassword';
import Signup from '../pages/Public/Signup';
import Onboarding from '../pages/Onboarding';
import General from '../pages/Dashboard/General';
import Preview from '../pages/Dashboard/Preview';
import PublishAndroid from '../pages/Dashboard/PublishAndroid';
import PublishIOS from '../pages/Dashboard/PublishIOS';
import AbandonedCartNotifications from '../pages/Dashboard/AbandonedCartNotifications';
import PushList from '../pages/Dashboard/Push/List';
import PushNew from '../pages/Dashboard/Push/New';
import PushDetail from '../pages/Dashboard/Push/Detail';
import Images from '../pages/Dashboard/Images';
import Theme from '../pages/Dashboard/Theme';
import Editor from '../pages/Dashboard/Theme/Editor';
import Pricing from '../pages/Dashboard/Pricing';
import Subscription from '../pages/Dashboard/Subscription';
import Invoice from '../pages/Public/Invoice';
import Account from '../pages/Dashboard/Account';
import Sellflux from '../pages/Dashboard/Sellflux';
import Coupons from '../pages/Dashboard/Coupons';
import LastViewedProductNotification from '../pages/Dashboard/LastViewedProductNotification';
import SubscriptionSuccess from '../pages/Dashboard/Subscription/Success';

export const PublicAppRouter = () => {
    return (
        <Router>
            <MetaPixelPageTracker />
            <GTagPageTracker />
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/registrar" element={<Signup />} />
                <Route path="/recuperar-senha" element={<ForgotPassword />} />
                <Route path="/alterar-senha" element={<ResetPassword />} />
                <Route path="/faturas/:invoiceId?" element={<Invoice />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </Router>
    )
}

export const PrivateAppRouter = () => {
    return (
        <Router>
            <MetaPixelPageTracker />
            <GTagPageTracker />
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/abandoned-cart-notifications" element={<AbandonedCartNotifications />} />
                <Route path="/last-viewed-product-notification" element={<LastViewedProductNotification />} />
                <Route path="/push" element={<PushList />} />
                <Route path="/push/new" element={<PushNew />} />
                <Route path="/push/:id" element={<PushDetail />} />
                <Route path="/sellflux" element={<Sellflux />} />
                <Route path="/coupons" element={<Coupons />} />
                <Route path="/general" element={<General />} />
                <Route path="/images" element={<Images />} />
                <Route path="/theme" element={<Theme />} />
                <Route path="/editor" element={<Editor />} />
                <Route path="/preview" element={<Preview />} />
                <Route path="/android" element={<PublishAndroid />} />
                <Route path="/ios" element={<PublishIOS />} />
                <Route path="/account" element={<Account />} /> 
                <Route path="/pricing" element={<Pricing fullScreen />} />
                <Route path="/pricing-ios" element={<Pricing />} />
                <Route path="/pricing-android" element={<Pricing />} />
                <Route path="/hire" element={<Subscription />} />
                <Route path="/faturas/:invoiceId?" element={<Invoice />} />
                <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    )
}

export const BillingRouter = () => {
    return (
        <Router>
            <MetaPixelPageTracker />
            <GTagPageTracker />
            <Routes>
                <Route path="/" element={<Pricing fullScreen />} />
                <Route path="/hire" element={<Subscription />} />
                <Route path="/faturas/:invoiceId?" element={<Invoice />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    )
}